const extraSmallBreakpointMin = 0;
const extraSmallBreakpointMax = 567;

const smallBreakpointMin = 568;
const smallBreakpointMax = 767;

const mediumBreakpointMin = 768;
const mediumBreakpointMax = 1024;

const largeBreakpointMin = 1025;
const largeBreakpointMax = 1440;

const extraLargeBreakpointMin = 1441;

function isBetween(number, min, max) {
    return (number >= min) && (number <= max);
}

/**
 * get SCSS breakpoint name for the specified width
 * If urbnweb/features/core/scss/core/susy/_breakpoints.scss breakpoint widths change,
 * this file will need to be updated to reflect that.
 *
 * @param  {number} width a width
 * @return {string}       one of the SCSS breakpoint names
 */
export function getBreakpointNameForWidth(width) {
    if (isBetween(width, extraSmallBreakpointMin, extraSmallBreakpointMax)) {
        return 'extra-small';
    } else if (isBetween(width, smallBreakpointMin, smallBreakpointMax)) {
        return 'small';
    } else if (isBetween(width, mediumBreakpointMin, mediumBreakpointMax)) {
        return 'medium';
    } else if (isBetween(width, largeBreakpointMin, largeBreakpointMax)) {
        return 'large';
    } else if (width >= extraLargeBreakpointMin) {
        return 'extra-large';
    } else {
        return undefined;
    }
}

export function isLargeScreen(width) {
    const largeScreenBreakpointNames = ['large', 'extra-large'];

    return largeScreenBreakpointNames.indexOf(getBreakpointNameForWidth(width)) !== -1;
}

/**
 * Attach the User Agent data to a data attribute on the HTML element
 * @return {object} Returns nothing
 */
export function attachUserAgentString() {
    const doc = document.documentElement;
    const userAgentString = navigator.userAgent;

    if (userAgentString.includes('MSIE 10.')) {
        doc.className = 'u-ie-10';
    }
}
